import React, {Fragment} from "react";
import Coupon from './coupon';

export default function TestimonialSent(props) {

    return <Fragment>`
        <div className={"large-icon blue-clap-icon mar-auto"}/>
        <h3 className="feedback__msg feedback__msg--with-space">Thanks for sharing!</h3>
        <p className={'feedback__txt'}>We truly appreciate you taking the time to share your experience with all our test-takers :)</p>
        <p className={'feedback__contact'}>Here’s your coupon as promised:</p>

        <Coupon coupon={props.coupon} />
    </Fragment>

}